/* ============================================================
   ZAGARA LUXURY — Selection Page JS v2
   ============================================================ */
(function () {
  'use strict';
  var I18N = (window.ZAGARA && window.ZAGARA.i18n) || {};

  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;

  // GSAP tweens bypass the CSS reduced-motion kill-switch (they write inline
  // styles), so every entrance/scrub animation must check this flag itself.
  const ZG_REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Utilities ─────────────────────────────────────────── */
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* Giro finale, voce 7 (foglio 01 §2.7): con «Featured» (nessun sort_by nell'URL, o «manual») i disponibili stanno
     prima di tutti gli esauriti, anche con «Load more» e coi filtri. Un ordinamento scelto dal cliente resta com'e'.
     data-available lo stampa zg-product-card ('true' / 'false', product.available). */
  const disponibile = card => card.dataset.available === 'true';
  function vistaFeatured() {
    const s = new URL(window.location.href).searchParams.get('sort_by');
    return !s || s === 'manual';
  }

  function splitIntoWords(el) {
    const raw = el.textContent.trim();
    el.innerHTML = raw.split(/\s+/).map(w =>
      `<span class="sw" style="display:inline-block;overflow:hidden;vertical-align:bottom">` +
      `<span class="swi" style="display:inline-block">${w}</span></span>`
    ).join(' ');
    return $$('.swi', el);
  }

  /* ── Hero ─────────────────────────────────────────────── */
  function initHero() {
    const hero = $('[data-col-hero]');
    if (!hero) return;

    // Giro finale, voce 12: niente comparsa JS sul titolo e sulla descrizione della copertina. La spezzatura in
    // parole + gsap.from (dal codice 0,2 + 1,5 + 2 x 0,065 = 1,83 s con tre parole, e solo dopo GSAP) nascondeva
    // il titolo dipinto dal server, e in ja/zh ne faceva una parola sola; la descrizione partiva da opacita' 0.
    // Ora la comparsa e' solo CSS (.zg-copertina-in in luxury.css, 480 ms + 60 ms, solo «translate»).

    // Parallax on bg image
    const bgImg = hero.querySelector('.col-hero__bg-img');
    if (bgImg && gsap && ScrollTrigger && !ZG_REDUCE) {
      gsap.to(bgImg, {
        yPercent: 22,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 1.6 },
      });
    }

    // Content fade-out on scroll
    const content = hero.querySelector('.col-hero__content');
    if (content && gsap && ScrollTrigger && !ZG_REDUCE) {
      gsap.to(content, {
        opacity: 0,
        y: -50,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: '25% top', end: '75% top', scrub: 1 },
      });
    }

    // Scroll cue line grow animation
    const line = hero.querySelector('.col-hero__scroll-line');
    if (line && gsap && !ZG_REDUCE) {
      gsap.fromTo(line,
        { scaleY: 0, transformOrigin: 'top center' },
        { scaleY: 1, duration: 1.8, ease: 'expo.out', delay: 1.2 }
      );
    }

    // Scroll-to-products
    const scrollBtn = $('[data-scroll-products]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', () => {
        const target = document.getElementById('colProducts');
        if (target) {
          const offset = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: offset, behavior: (window.zgScrollBehavior || (() => 'smooth'))() });
        }
      });
    }
  }


  /* ── Scroll Reveals ───────────────────────────────────── */
  function initReveals() {
    if (!gsap || !ScrollTrigger) return;
    // Reduced motion: skip entrance tweens and the scrub parallax entirely —
    // content simply renders in place (nothing here pre-hides via CSS).
    if (ZG_REDUCE) return;

    // Generic reveals (outside hero)
    $$('[data-col-reveal]').forEach(el => {
      if (el.closest('[data-col-hero]')) return;
      gsap.from(el, {
        opacity: 0,
        y: 38,
        duration: 1.1,
        ease: 'expo.out',
        scrollTrigger: { trigger: el, start: 'top 90%', toggleActions: 'play none none none' },
      });
    });

    // Title word splits (editorial)
    $$('[data-col-split]').forEach(el => {
      if (el.closest('[data-col-hero]')) return;
      const words = splitIntoWords(el);
      gsap.from(words, {
        yPercent: 110,
        duration: 1.3,
        stagger: 0.06,
        ease: 'expo.out',
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' },
      });
    });

    // Product cards stagger
    animateCardsIn($$('.col-card'));

    // Editorial parallax
    const editorial = $('[data-col-editorial]');
    if (editorial) {
      const img = editorial.querySelector('img');
      if (img) {
        gsap.to(img, {
          yPercent: 14,
          ease: 'none',
          scrollTrigger: { trigger: editorial, start: 'top bottom', end: 'bottom top', scrub: 2 },
        });
      }
    }
  }

  function animateCardsIn(cards, delay = 0) {
    if (!gsap || !cards.length || ZG_REDUCE) return;
    // Start hidden (avoids a flash), then reveal in batches as they enter the
    // viewport — smoother than firing all cards in one long staggered tween.
    // transition:none stops the .col-card CSS transform transition from
    // re-interpolating every GSAP tick (damped/mushy reveal); clearProps
    // restores it afterwards so the CSS hover lift keeps animating.
    gsap.set(cards, { opacity: 0, y: 54, transition: 'none' });
    ScrollTrigger.batch(cards, {
      start: 'top 92%',
      onEnter: batch => gsap.to(batch, {
        opacity: 1,
        y: 0,
        duration: 0.85,
        stagger: { each: 0.065, from: 'start' },
        ease: 'expo.out',
        delay,
        overwrite: true,
        clearProps: 'transform,opacity,transition',
      }),
    });
  }


  /* ── 3D Card Tilt ─────────────────────────────────────── */
  function initCardTilt() {
    function attachTilt() {
      $$('.col-card').forEach(card => {
        card.removeEventListener('mouseenter', onEnter);
        card.addEventListener('mouseenter', onEnter);
      });
    }

    function onEnter() {
      const card = this;
      card._rect = card.getBoundingClientRect();   // cache once; avoids layout read on every move
      card.style.willChange = 'transform';         // just-in-time promotion; cleared in onLeave
      const move = onMove.bind(card);
      const leave = onLeave.bind(card);
      card._move = move;
      card._leave = leave;
      card.addEventListener('mousemove', move, { passive: true });
      card.addEventListener('mouseleave', leave, { once: true });
    }

    function onMove(e) {
      const rect = this._rect || this.getBoundingClientRect();
      const dx = (e.clientX - rect.left - rect.width / 2) / (rect.width / 2);
      const dy = (e.clientY - rect.top - rect.height / 2) / (rect.height / 2);
      if (gsap) {
        gsap.to(this, {
          rotateX: -dy * 9,
          rotateY: dx * 9,
          transformPerspective: 1100,
          z: 20,
          duration: 0.55,
          ease: 'power2.out',
        });
        const shine = this.querySelector('.col-card__shine');
        if (shine) {
          gsap.to(shine, {
            opacity: 1,
            background: `radial-gradient(circle at ${50 + dx * 35}% ${50 + dy * 35}%, rgba(201,169,97,.36) 0%, transparent 65%)`,
            duration: 0.4,
          });
        }
      }
    }

    function onLeave() {
      if (gsap) {
        gsap.to(this, { rotateX: 0, rotateY: 0, z: 0, duration: 0.9, ease: 'expo.out' });
        const shine = this.querySelector('.col-card__shine');
        if (shine) gsap.to(shine, { opacity: 0, duration: 0.5 });
      }
      this.removeEventListener('mousemove', this._move);
      this.style.willChange = '';
    }

    attachTilt();
    document.addEventListener('col:gridUpdated', attachTilt);
  }


  /* ── Sticky Filter Bar ────────────────────────────────── */
  function initStickyBar() {
    const bar = document.getElementById('lxfBar');
    if (!bar) return;

    // Top is handled in CSS: calc(var(--announce-h) + header height).
    // (Previously this set top = header.offsetHeight, ignoring the fixed
    //  announcement bar above the header, which detached the filter bar.)

    const hero = $('[data-col-hero]');
    if (!hero) {
      bar.classList.add('lxf-bar--visible');
      return;
    }

    // Use IntersectionObserver — works independently of Lenis or any scroll lib
    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      bar.classList.toggle('lxf-bar--visible', show);
    }, { threshold: 0 });

    observer.observe(hero);
  }


  /* ── Filter System ────────────────────────────────────── */
  function initFilters() {
    const resultsEl = $('[data-results-count]');
    const grid = document.getElementById('colProductGrid');

    /* Giro finale, voce 7: la fila d'apertura (heroRow) e le categorie a turno si fanno DUE volte, prima sui disponibili
       e poi sugli esauriti, che vanno tutti in coda (anche quelli della fila d'apertura). Prima l'alternanza non guardava
       data-available e cancellava le due passate del server: il primo della fila, la crema di pistacchio esaurita, era il
       primo prodotto del catalogo. Al boot, con altre pagine da leggere, gli esauriti della prima pagina non sono nella
       griglia (li trattiene initLoadMore): qui restano i soli disponibili. */
    function organizeFeaturedGrid() {
      if (!grid) return;
      if (!vistaFeatured()) return;

      const heroRow = [
        'testa-moro-igp-sicilia',
        'evergreen-crema-pistacchio',
        'rds-sugo-norma',
        'biscottini-limone',
        'polara-aranciata-rossa',
        'the-sicilian-table-box',
      ];
      const priority = [
        'olive-oil',
        'pistachio-almond',
        'conserves-sauces',
        'biscuits-sweets',
        'sicilian-drinks',
        'gift-boxes',
        'pantry-staples',
      ];
      function alternanza(cards) {
        const buckets = new Map(priority.map(key => [key, []]));
        const rest = [];
        const ordered = [];

        heroRow.forEach(handle => {
          const card = cards.find(item => item.dataset.handle === handle);
          if (card) ordered.push(card);
        });

        cards.forEach(card => {
          if (ordered.includes(card)) return;
          const category = (card.dataset.category || '').split(',')[0];
          if (buckets.has(category)) buckets.get(category).push(card);
          else rest.push(card);
        });

        let added = true;
        while (added) {
          added = false;
          priority.forEach(key => {
            const next = buckets.get(key).shift();
            if (next) {
              ordered.push(next);
              added = true;
            }
          });
        }
        ordered.push(...rest);
        return ordered;
      }

      const cards = $$('.col-card', grid);
      const ordered = [...alternanza(cards.filter(disponibile)), ...alternanza(cards.filter(card => !disponibile(card)))];
      ordered.forEach(card => grid.appendChild(card));
      placeGiftCta($$('.col-card', grid).filter(card => !card.hasAttribute('hidden')));
    }

    function placeGiftCta(visibleCards) {
      if (!grid) return;
      const cta = $('[data-grid-gift-cta]', grid);
      if (!cta) return;
      const cards = visibleCards || $$('.col-card', grid).filter(card => !card.hasAttribute('hidden'));
      cta.toggleAttribute('hidden', cards.length <= 12);
      const anchor = cards[11];
      if (anchor && anchor.nextSibling !== cta) {
        anchor.insertAdjacentElement('afterend', cta);
      } else if (!anchor) {
        grid.appendChild(cta);
      }
    }

    /* Giro finale, voce 6 (foglio 03 §2.10), per l'LCP: le schede della prima fila MOSTRATA partono subito (loading
       eager) e la prima ha fetchpriority high, le altre restano lazy. La prima fila sono le colonne vere della griglia,
       lette dal CSS calcolato (zg-collection.css: 2 al telefono, 3 fra 768 e 1023, «cozy» una in meno, la compatta del
       telefono 3; dai 1024 auto-fill, foglio 07 §3: 4-6 in compatta, 3-5 in «cozy», 3 nelle collezioni piccole fino ai
       1440). Prima il tetto era 4 colonne: con 5 e 6 (a 1366 e 1512) l'ultima scheda della prima fila restava lazy. Il
       tetto ora e' 8, solo una rete. Qui e non nel Liquid: con «Featured» l'ordine lo fa organizeFeaturedGrid() qui
       sotto (la fila d'apertura heroRow, poi le categorie a turno) e la prima scheda del server finisce piu' giu'; con
       un ordinamento scelto (?sort_by) l'ordine resta quello del server e vale lo stesso conto. Una volta, all'avvio. Con i filtri
       nell'URL no: le schede mostrate le decide applyFilters dopo l'indice intero (asincrono), e restano tutte lazy. */
    function primaFila() {
      if (!grid) return;
      if (/[?&](availability|category|categories|vendor|vendors|price)=/.test(window.location.search)) return;
      const colonne = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      const prime = $$('.col-card', grid).filter(card => !card.hasAttribute('hidden')).slice(0, Math.min(colonne, 8));
      prime.forEach((card, i) => {
        const img = card.querySelector('img.col-card__bg');
        if (!img) return;
        if (i === 0) img.setAttribute('fetchpriority', 'high');
        img.loading = 'eager';
      });
    }

    organizeFeaturedGrid();
    primaFila();
    /* blocco 8A ramo (b): la barra non si semina mai da un conteggio DOM di
       pagina 1 — il totale vero non esiste al primo disegno. Senza filtri
       scrive solo initLoadMore quando zgLm.complete e' vero; sotto filtri
       scrive applyFiltersNow, che passa da withFullIndex. */

    const fState = {
      priceRanges: [],   // [{min, max}] in cents
      vendors: new Set(),
      categories: new Set(),
      availability: new Set(),
    };

    const labelDefaults = {
      price: (I18N.filterLabels || {}).price || 'Price',
      vendor: (I18N.filterLabels || {}).vendor || 'Producer',
      category: (I18N.filterLabels || {}).category || 'Category',
      availability: (I18N.filterLabels || {}).availability || 'Availability',
    };

    function setFromCheckbox(set, cb, value) {
      cb.checked ? set.add(value) : set.delete(value);
    }

    function syncFiltersFromUrl() {
      const params = new URL(window.location.href).searchParams;
      const values = {
        category: (params.get('category') || params.get('categories') || '').split(',').filter(Boolean),
        vendor: (params.get('vendor') || params.get('vendors') || '').split(',').filter(Boolean),
        availability: (params.get('availability') || '').split(',').filter(Boolean),
        price: (params.get('price') || '').split(',').filter(Boolean),
      };

      values.category.forEach(value => fState.categories.add(value));
      values.vendor.forEach(value => fState.vendors.add(value));
      values.availability.forEach(value => fState.availability.add(value));
      values.price.forEach(value => {
        const [min, max] = value.split('-').map(Number);
        if (Number.isFinite(min) && Number.isFinite(max)) fState.priceRanges.push({ min, max });
      });

      $$('[data-lxf-category]').forEach(cb => { cb.checked = fState.categories.has(cb.dataset.lxfCategory); });
      $$('[data-lxf-vendor]').forEach(cb => { cb.checked = fState.vendors.has(cb.dataset.lxfVendor); });
      $$('[data-lxf-availability]').forEach(cb => { cb.checked = fState.availability.has(cb.dataset.lxfAvailability); });
      $$('[data-lxf-price]').forEach(cb => {
        const [min, max] = cb.dataset.lxfPrice.split('-').map(Number);
        cb.checked = fState.priceRanges.some(range => range.min === min && range.max === max);
      });
    }

    function updateFilterLabels() {
      $$('[data-lxf-group]').forEach(group => {
        const trigger = group.querySelector('[data-lxf-trigger]');
        const dropdown = group.querySelector('[data-lxf-dropdown]');
        const labelEl = trigger && trigger.querySelector('[data-lxf-label]');
        const groupKey = group.dataset.lxfGroup;
        if (!trigger || !dropdown || !labelEl) return;
        const count = dropdown.querySelectorAll('input:checked').length;
        labelEl.textContent = count > 0
          ? `${labelDefaults[groupKey] || groupKey} (${count})`
          : labelDefaults[groupKey] || groupKey;
        trigger.classList.toggle('lxf-btn--active', count > 0);
      });
    }

    function writeFilterUrl() {
      const url = new URL(window.location.href);
      const category = [...fState.categories];
      const vendor = [...fState.vendors];
      const availability = [...fState.availability];
      const price = fState.priceRanges.map(range => `${range.min}-${range.max}`);

      category.length ? url.searchParams.set('category', category.join(',')) : url.searchParams.delete('category');
      vendor.length ? url.searchParams.set('vendor', vendor.join(',')) : url.searchParams.delete('vendor');
      availability.length ? url.searchParams.set('availability', availability.join(',')) : url.searchParams.delete('availability');
      price.length ? url.searchParams.set('price', price.join(',')) : url.searchParams.delete('price');
      history.replaceState({}, '', url.toString());
    }

    function cardHasToken(card, key, selected) {
      if (selected.size === 0) return true;
      const tokens = (card.dataset[key] || '').split(',').filter(Boolean);
      return [...selected].some(value => tokens.includes(value));
    }

    /* Dropdown groups */
    syncFiltersFromUrl();

    $$('[data-lxf-group]').forEach(group => {
      const trigger  = group.querySelector('[data-lxf-trigger]');
      const dropdown = group.querySelector('[data-lxf-dropdown]');
      const labelEl  = trigger && trigger.querySelector('[data-lxf-label]');
      const groupKey = group.dataset.lxfGroup;
      if (!trigger || !dropdown) return;

      trigger.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        /* Close all others */
        $$('[data-lxf-group]').forEach(g => {
          if (g === group) return;
          const t = g.querySelector('[data-lxf-trigger]');
          const d = g.querySelector('[data-lxf-dropdown]');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (d) d.setAttribute('hidden', '');
          g.classList.remove('lxf-group--open');
        });

        const next = !isOpen;
        trigger.setAttribute('aria-expanded', next);
        next ? dropdown.removeAttribute('hidden') : dropdown.setAttribute('hidden', '');
        group.classList.toggle('lxf-group--open', next);
      });

      /* Checkbox changes */
      dropdown.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.addEventListener('change', () => {
          if (cb.dataset.lxfPrice) {
            const [mn, mx] = cb.dataset.lxfPrice.split('-').map(Number);
            if (cb.checked) fState.priceRanges.push({ min: mn, max: mx });
            else fState.priceRanges = fState.priceRanges.filter(r => !(r.min === mn && r.max === mx));
          }
          if (cb.dataset.lxfVendor) {
            setFromCheckbox(fState.vendors, cb, cb.dataset.lxfVendor);
          }
          if (cb.dataset.lxfCategory) {
            setFromCheckbox(fState.categories, cb, cb.dataset.lxfCategory);
          }
          if (cb.dataset.lxfAvailability) {
            setFromCheckbox(fState.availability, cb, cb.dataset.lxfAvailability);
          }

          const count = dropdown.querySelectorAll('input:checked').length;
          if (labelEl) {
            labelEl.textContent = count > 0
              ? `${labelDefaults[groupKey] || groupKey} (${count})`
              : labelDefaults[groupKey] || groupKey;
          }
          trigger.classList.toggle('lxf-btn--active', count > 0);
          applyFilters();
        });
      });
    });

    updateFilterLabels();
    applyFilters();

    /* Close dropdowns on outside click — replace (not stack) the previous
       binding when boot() re-runs after a theme-editor section re-render */
    if (window.__zgLxfDocClose) document.removeEventListener('click', window.__zgLxfDocClose);
    window.__zgLxfDocClose = e => {
      if (e.target.closest('[data-lxf-group]')) return;
      $$('[data-lxf-group]').forEach(g => {
        const t = g.querySelector('[data-lxf-trigger]');
        const d = g.querySelector('[data-lxf-dropdown]');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (d) d.setAttribute('hidden', '');
        g.classList.remove('lxf-group--open');
      });
    };
    document.addEventListener('click', window.__zgLxfDocClose);

    /* Giro finale, foglio 07, voce f07b-filtri-esc: prima le tendine si chiudevano solo col clic e, lasciate aperte,
       coprivano le prime schede e l'anello del fuoco (WCAG 2.4.11). Ora Esc chiude la tendina aperta e riporta il fuoco
       sul suo bottone (se il fuoco era nel gruppo o su un suo contenitore: body, o <main tabindex="-1">; Safari col clic
       non lo mette sul bottone); il fuoco che entra in un elemento fuori dal gruppo (Tab, Maiusc+Tab; in Chrome anche il
       clic su un cuore, che __zgLxfDocClose non vede) la chiude, anche quando partiva da un contenitore del gruppo (body,
       <main tabindex="-1">): per questo e' un focusin
       sul documento e non un focusout del gruppo (correzione del revisore, D1). Il fuoco che non va a nessuno (finestra
       lasciata) o che sale a un contenitore del gruppo (Chrome, al clic su una spunta o su una zona vuota della tendina,
       lo da' a <main tabindex="-1">) non la chiude: per il clic fuori resta __zgLxfDocClose. */
    const closeLxfGroup = g => {
      const t = g.querySelector('[data-lxf-trigger]');
      const d = g.querySelector('[data-lxf-dropdown]');
      if (!t || t.getAttribute('aria-expanded') !== 'true') return false;
      t.setAttribute('aria-expanded', 'false');
      if (d) d.setAttribute('hidden', '');
      g.classList.remove('lxf-group--open');
      return true;
    };
    if (window.__zgLxfFocusIn) document.removeEventListener('focusin', window.__zgLxfFocusIn);
    window.__zgLxfFocusIn = e => {
      const to = e.target;
      if (!to || to.nodeType !== 1) return;
      $$('[data-lxf-group]').forEach(g => { if (!g.contains(to) && !to.contains(g)) closeLxfGroup(g); });
    };
    document.addEventListener('focusin', window.__zgLxfFocusIn);
    if (window.__zgLxfEsc) document.removeEventListener('keydown', window.__zgLxfEsc);
    window.__zgLxfEsc = e => {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      $$('[data-lxf-group]').forEach(g => {
        const a = document.activeElement;
        const back = !a || g.contains(a) || a.contains(g);
        if (!closeLxfGroup(g)) return;
        const t = g.querySelector('[data-lxf-trigger]');
        if (back && t) t.focus();
      });
    };
    document.addEventListener('keydown', window.__zgLxfEsc);

    /* Sort — client-side, no page reload */
    const sortSelect = $('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const value = sortSelect.value;
        const grid = document.getElementById('colProductGrid');
        if (!grid) return;

        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);

        /* Best selling requires server-side sales data — navigate */
        if (value === 'best-selling') {
          window.location.assign(url.toString());
          return;
        }

        /* client-side reorder needs the FULL index (same guard as filters) */
        withFullIndex(() => {
        /* Featured — restore the curated manual order client-side */
        if (value === 'manual') {
          history.replaceState({}, '', url.toString());
          const manualCards = $$('.col-card', grid);
          if (gsap) gsap.killTweensOf(manualCards);
          organizeFeaturedGrid();
          if (gsap) {
            gsap.from($$('.col-card', grid), { opacity: 0, y: 22, duration: 0.55, stagger: 0.04, ease: 'expo.out', clearProps: 'transform,opacity,transition' });
          }
          return;
        }

        const cards = $$('.col-card', grid);

        cards.sort((a, b) => {
          switch (value) {
            case 'price-ascending':  return +a.dataset.price - +b.dataset.price;
            case 'price-descending': return +b.dataset.price - +a.dataset.price;
            case 'title-ascending':  return (a.dataset.title || '').localeCompare(b.dataset.title || '');
            case 'title-descending': return (b.dataset.title || '').localeCompare(a.dataset.title || '');
            case 'created-descending': return +b.dataset.created - +a.dataset.created;
            case 'created-ascending':  return +a.dataset.created - +b.dataset.created;
            default: return 0;
          }
        });

        if (gsap) gsap.killTweensOf(cards);
        cards.forEach(card => grid.appendChild(card));

        if (gsap) {
          gsap.from(cards, { opacity: 0, y: 22, duration: 0.55, stagger: 0.04, ease: 'expo.out', clearProps: 'transform,opacity,transition' });
        }

        history.replaceState({}, '', url.toString());
        }); // withFullIndex
      });
    }

    function applyFilters() {
      /* pagination interplay: while any filter is active the Load More UI is
         suspended and the FULL index must be in the DOM before matching —
         withFullIndex handles the not-yet-prefetched gap gracefully. With no
         filters active, skip the guard so plain pageviews stay paginated. */
      const active = fState.vendors.size > 0 || fState.categories.size > 0 ||
                     fState.availability.size > 0 || fState.priceRanges.length > 0;
      if (window.zgLm && window.zgLm.wrap) window.zgLm.wrap.toggleAttribute('hidden', active);
      if (active) withFullIndex(applyFiltersNow);
      else applyFiltersNow();
    }

    function applyFiltersNow() {
      const grid = document.getElementById('colProductGrid');
      if (!grid) return;
      const cards = $$('.col-card', grid);
      const show = [];
      const hide = [];

      cards.forEach(card => {
        let match = true;
        if (fState.vendors.size > 0 && !fState.vendors.has(card.dataset.vendor)) match = false;
        if (!cardHasToken(card, 'category', fState.categories)) match = false;
        if (!cardHasToken(card, 'availabilityState', fState.availability)) match = false;
        if (fState.priceRanges.length > 0) {
          const priceC = +card.dataset.price;
          if (!fState.priceRanges.some(r => priceC >= r.min && priceC <= r.max)) match = false;
        }
        (match ? show : hide).push(card);
      });

      /* Giro finale, voce 7: con «Featured» le schede mostrate escono prima disponibili e poi esaurite, a parita' di
         gruppo nell'ordine della griglia (stabile). Di norma la griglia lo e' gia' (organizeFeaturedGrid e Load more);
         qui regge coi filtri anche dove non lo e' (una prima pagina senza disponibili: initLoadMore non trattiene niente
         e le pagine dopo arrivano in coda). Le schede si riaccodano comunque tutte qui sotto: nessuno spostamento in piu'.
         Un ordinamento scelto resta com'e'. */
      if (vistaFeatured()) {
        const prima = show.filter(disponibile);
        const dopo = show.filter(card => !disponibile(card));
        show.length = 0;
        show.push(...prima, ...dopo);
      }

      if (gsap) {
        gsap.killTweensOf(cards);
        // clear stale enter-animation transforms (y offset) so cards can't overlap
        // what follows; 'transition' too, or a reveal interrupted mid-tween strands
        // its inline transition:none and hover lift snaps instead of easing
        gsap.set(cards, { clearProps: 'transform,transition' });
      }

      /* Re-order DOM: visible cards first so the grid compacts from top-left */
      show.forEach(card => {
        card.removeAttribute('hidden');
        card.style.opacity = '0';
        grid.appendChild(card);
      });
      placeGiftCta(show);
      hide.forEach(card => {
        card.setAttribute('hidden', '');
        grid.appendChild(card);
      });
      /* Giro finale, voce 6: qui l'ordine della griglia e' quello finale (Featured riordinato, filtri applicati), e le
         schede mostrate sono a opacita' 0 in linea: la griglia si puo' vedere. zg-collection.css la tiene invisibile fino
         a qui (solo sotto html.js; un'animazione di sicurezza la mostra comunque a 4 s). Con la copertina corta la prima
         fila sta nella prima schermata: senza, al telefono si dipingeva nell'ordine del server, poi il riordino la
         spostava (CLS 0,24 a 390x844 con CPU 4x sul banco) e GSAP la nascondeva per rifarla comparire. */
      grid.classList.add('zg-griglia-pronta');

      if (gsap && show.length) {
        gsap.to(show, { opacity: 1, duration: 0.45, stagger: 0.045, ease: 'expo.out', clearProps: 'opacity' });
      } else {
        show.forEach(c => c.style.removeProperty('opacity'));
      }

      if (ScrollTrigger) ScrollTrigger.refresh();

      setTimeout(() => {
        // solo a indice completo: un conteggio su indice parziale e' un
        // numero falso (blocco 8A). Sotto filtri withFullIndex garantisce
        // il completo; senza filtri la barra resta vuota finche' non lo e'.
        if (resultsEl && (!window.zgLm || window.zgLm.complete)) resultsEl.textContent = show.length === 1
          ? (I18N.resultsOne || '1 result')
          : (I18N.resultsOther || '9999 results').replace('9999', show.length);
      }, 320);

      writeFilterUrl();
      const emptyEl = document.querySelector('[data-filter-empty]');
      if (emptyEl) emptyEl.toggleAttribute('hidden', show.length > 0);
      document.dispatchEvent(new Event('col:gridUpdated'));
    }

    function clearAllFilters() {
      fState.categories.clear();
      fState.vendors.clear();
      fState.availability.clear();
      fState.priceRanges = [];
      $$('[data-lxf-category], [data-lxf-vendor], [data-lxf-availability], [data-lxf-price]').forEach(cb => { cb.checked = false; });
      updateFilterLabels();
      applyFilters();
    }
    const emptyClear = document.querySelector('[data-filter-empty-clear]');
    if (emptyClear) emptyClear.addEventListener('click', clearAllFilters);
    const barClear = document.querySelector('[data-lxf-clear-all]');
    if (barClear) barClear.addEventListener('click', clearAllFilters);

    /* blocco 8: pastiglie dei filtri attivi. L'etichetta riusa il testo
       gia' localizzato della checkbox; il click riusa la strada esistente
       (cb.click() -> stesso handler dei filtri). */
    function renderPills() {
      const box = document.querySelector('[data-lxf-pills]');
      if (!box) return;
      const checked = $$('.lxf-dropdown input:checked');
      box.textContent = '';
      checked.forEach(cb => {
        const sp = cb.closest('label') && cb.closest('label').querySelector('span');
        const label = sp ? (sp.dataset.baseLabel || sp.textContent.trim()) : '';
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'lxf-pill';
        pill.innerHTML = '<span>' + label.replace(/</g, '&lt;') + '</span><span class="lxf-pill__x" aria-hidden="true">\u00d7</span>';
        pill.addEventListener('click', () => cb.click());
        box.appendChild(pill);
      });
      const attivi = checked.length > 0;
      box.toggleAttribute('hidden', !attivi);
      if (barClear) barClear.toggleAttribute('hidden', !attivi);
    }
    document.addEventListener('col:gridUpdated', renderPills);
    renderPills();

    /* blocco 8 B: contatori di faccetta, calcolati SOLO sull'indice
       completo (zgLm.complete) - un numero parziale sarebbe una bugia.
       Semantica: il valore + i filtri attivi degli ALTRI gruppi. La
       logica di match e' riusata (cardHasToken), non duplicata. */
    function computeFacetCounts() {
      if (!(window.zgLm && window.zgLm.complete)) return;
      const grid2 = document.getElementById('colProductGrid');
      if (!grid2) return;
      const cards = $$('.col-card', grid2);
      $$('.lxf-dropdown input').forEach(cb => {
        let group, val;
        if (cb.dataset.lxfCategory !== undefined) { group = 'category'; val = cb.dataset.lxfCategory; }
        else if (cb.dataset.lxfVendor !== undefined) { group = 'vendor'; val = cb.dataset.lxfVendor; }
        else if (cb.dataset.lxfAvailability !== undefined) { group = 'availability'; val = cb.dataset.lxfAvailability; }
        else if (cb.dataset.lxfPrice !== undefined) { group = 'price'; val = cb.dataset.lxfPrice; }
        else return;
        let n = 0;
        const one = new Set([val]);
        cards.forEach(card => {
          if (group === 'vendor') { if (card.dataset.vendor !== val) return; }
          else if (fState.vendors.size > 0 && !fState.vendors.has(card.dataset.vendor)) return;
          if (group === 'category') { if (!cardHasToken(card, 'category', one)) return; }
          else if (!cardHasToken(card, 'category', fState.categories)) return;
          if (group === 'availability') { if (!cardHasToken(card, 'availabilityState', one)) return; }
          else if (!cardHasToken(card, 'availabilityState', fState.availability)) return;
          if (group === 'price') { const pr = val.split('-').map(Number); const pz = +card.dataset.price; if (!(pz >= pr[0] && pz <= pr[1])) return; }
          else if (fState.priceRanges.length > 0) { const pz = +card.dataset.price; if (!fState.priceRanges.some(r => pz >= r.min && pz <= r.max)) return; }
          n++;
        });
        const span = cb.closest('label') && cb.closest('label').querySelector('span');
        if (span) {
          if (!span.dataset.baseLabel) span.dataset.baseLabel = span.textContent.trim();
          span.textContent = span.dataset.baseLabel + ' (' + n + ')';
        }
        const zero = n === 0 && !cb.checked;
        cb.disabled = zero;
        cb.setAttribute('aria-disabled', zero ? 'true' : 'false');
        if (cb.closest('label')) cb.closest('label').classList.toggle('lxf-check--zero', zero);
      });
    }
    document.addEventListener('col:gridUpdated', computeFacetCounts);
    const facetTick = setInterval(() => {
      if (window.zgLm && window.zgLm.complete) { clearInterval(facetTick); computeFacetCounts(); }
    }, 400);
  }


  /* ── Load More: 24 rendered server-side, the rest fetched from real
     ?page URLs. An idle prefetch fills a buffer so Load More is usually
     instant and the client-side filter/sort systems can ask for the FULL
     index before operating (never over a partial set). ── */
  function initLoadMore() {
    const wrap = $('[data-zg-loadmore-wrap]');
    const grid = document.getElementById('colProductGrid');
    // no wrap = single page: the full index is already in the DOM
    window.zgLm = { complete: !wrap, ensureAll: function () { return Promise.resolve(); }, wrap: wrap };
    if (!wrap || !grid) return;

    const btn = wrap.querySelector('[data-zg-loadmore]');
    const live = wrap.querySelector('[data-zg-lm-live]');
    const countEl = wrap.querySelector('[data-zg-lm-count]');
    /* products_count includes items the grid loop intentionally skips
       (gift-builder internals), so the server total can overcount by a few.
       Once the prefetch chain exhausts we KNOW the real total and reconcile
       every counter (this also fixes the pre-existing RESULTS overcount). */
    let total = +btn.dataset.total || 0;
    const pageSize = +btn.dataset.pageSize || 24;
    const resultsEl = $('[data-results-count]');
    let nextUrl = btn.dataset.nextUrl || '';
    let fetching = null;
    let reconciled = false;

    /* Giro finale, voce 7: gli esauriti in fondo anche fra le pagine. Il server mette i disponibili prima dentro OGNI
       pagina (le due passate di main-collection), ma gli esauriti di pagina 1 stavano prima dei disponibili di pagina 2.
       Con «Featured» e altre pagine da leggere, gli esauriti della prima pagina escono dalla griglia (held) PRIMA delle
       comparse di initReveals (che mette opacity 0 in linea: una scheda staccata dopo resterebbe invisibile al ritorno);
       le pagine lette si dividono in disponibili (bufA) ed esaurite (bufS). Si accoda da bufA; held e poi bufS solo a
       pagine finite, quando non ci sono piu' disponibili da caricare. Se la prima pagina non ha nessun disponibile non si
       trattiene niente (la griglia non nasce vuota). Senza JS resta l'ordine del server, pagina per pagina. Con un
       ordinamento scelto (sort_by nell'URL) tutto va in bufA, nell'ordine del server, come prima. */
    const trattieni = !!nextUrl && vistaFeatured() && $$('.col-card', grid).some(disponibile);
    const held = trattieni ? $$('.col-card', grid).filter(card => !disponibile(card)) : [];
    held.forEach(card => card.remove());
    let bufA = [];
    let bufS = [];
    function resto() { return bufA.length + held.length + bufS.length; }
    /* Correzioni del revisore (voce 7): forza = una lettura di pagina e' appena fallita (rete). Allora si accodano anche
       held e bufS, cioe' schede che il server ha gia' mandato: senza, restavano fuori dalla griglia finche' una lettura non
       riusciva, e «Load more» aggiungeva 0 (sulla punta di prima, nello stesso guasto, le 50 schede restavano visibili).
       Se poi una lettura riesce, i disponibili delle pagine dopo arrivano in coda, dopo questi esauriti: le schede gia'
       sullo schermo non si spostano. Con un 429 o un 500 non serve: la pagina d'errore non ha [data-zg-loadmore] e
       nextUrl diventa ''. */
    function prendi(n, forza) {
      const chunk = bufA.splice(0, n);
      if (!nextUrl || forza) {
        if (chunk.length < n) chunk.push(...held.splice(0, n - chunk.length));
        if (chunk.length < n) chunk.push(...bufS.splice(0, n - chunk.length));
      }
      return chunk;
    }

    function inDom() { return $$('.col-card', grid).length; }
    function tpl(str, map) {
      return Object.keys(map).reduce((s, k) => s.replace('%' + k + '%', map[k]), str || '');
    }

    function fetchNext() {
      if (!nextUrl) return Promise.resolve(false);
      if (fetching) return fetching;
      fetching = fetch(nextUrl, { headers: { Accept: 'text/html' } })
        .then(r => r.text())
        .then(htmlText => {
          const doc = new DOMParser().parseFromString(htmlText, 'text/html');
          doc.querySelectorAll('#colProductGrid > .col-card').forEach(c => {
            const card = document.importNode(c, true);
            (trattieni && !disponibile(card) ? bufS : bufA).push(card);
          });
          const nb = doc.querySelector('[data-zg-loadmore]');
          nextUrl = (nb && nb.dataset.nextUrl) || '';
          fetching = null;
          if (!nextUrl && !reconciled) {
            reconciled = true;
            total = inDom() + resto();
            updateCount();
            writeBarTotal(); // blocco 8B ramo (a): qui la fonte E' il totale vero
          }
          if (!nextUrl && !resto()) { window.zgLm.complete = true; writeBarTotal(); }
          return true;
        })
        .catch(() => { fetching = null; return false; });
      return fetching;
    }

    /* background prefetch: cheap at this catalog size (2 extra pages) */
    (function idleChain() {
      if (!nextUrl) return;
      const cb = () => fetchNext().then(ok => { if (ok && nextUrl) idleChain(); });
      if ('requestIdleCallback' in window) requestIdleCallback(cb, { timeout: 4000 });
      else setTimeout(cb, 1500);
    })();

    /* Tappa 1b (critico della tappa 1, basso 15; voce 14): le stelline di Judge.me sulle schede che arrivano dalle
       pagine dopo la prima. Il badge della scheda (zg-product-card) esce solo se il prodotto ha recensioni e porta gia'
       l'HTML del metacampo judgeme.badge, come il codice Liquid di Judge.me (guida 12058208); lo script dell'app lo
       sistema con jdgm.customizeBadges(), la funzione pubblica che chiama da se' all'avvio e da un suo
       MutationObserver, e che prende solo i badge non ancora sistemati (widget/main.js dell'app, letto l'08/10/2026).
       Qui la si chiama una volta dopo l'aggiunta, se fra le schede nuove c'e' un badge e se lo script c'e': senza
       recensioni non c'e' nessun badge e non si chiama niente; senza lo script (nessun badge nella prima pagina, l'app
       non si carica) il badge resta l'HTML del metacampo. */
    function stellineJudgeme(chunk) {
      if (!chunk.some(c => c.querySelector('.jdgm-preview-badge'))) return;
      const jdgm = window.jdgm;
      if (!jdgm || typeof jdgm.customizeBadges !== 'function') return;
      try { jdgm.customizeBadges(); } catch (e) { /* l'app e' di terzi: un suo errore non ferma Load more */ }
    }

    function appendChunk(n, forza) {
      const chunk = prendi(n, forza);
      if (!chunk.length) return 0;
      const frag = document.createDocumentFragment();
      chunk.forEach(c => frag.appendChild(c));
      grid.appendChild(frag);
      stellineJudgeme(chunk);
      document.dispatchEvent(new Event('col:gridUpdated')); // wishlist heart re-sync etc.
      return chunk.length;
    }

    function updateCount() {
      // blocco 8B: prima della riconciliazione `total` e' il lordo del
      // server (sovraconta gli aiutanti) — non e' il totale vero, e un
      // numero che non e' vero non si scrive. Il piede resta vuoto.
      if (!reconciled) return;
      const shown = Math.min(inDom(), total);
      if (countEl) countEl.textContent = tpl(I18N.lmCountShown || '%SHOWN% of %TOTAL%', { SHOWN: shown, TOTAL: total });
    }

    /* blocco 8A ramo (b): l'UNICA scrittura della barra senza filtri.
       Scatta quando l'indice e' completo e il totale e' riconciliato; il
       wrap sospeso (attributo hidden, posato da applyFilters) significa
       filtri attivi, e li' il numero giusto lo scrive applyFiltersNow. */
    function writeBarTotal() {
      if (!resultsEl || wrap.hasAttribute('hidden')) return;
      resultsEl.textContent = total === 1
        ? (I18N.resultsOne || '1 result')
        : (I18N.resultsOther || '9999 results').replace('9999', total);
    }

    function finishIfExhausted() {
      if (!nextUrl && !resto()) {
        window.zgLm.complete = true;
        writeBarTotal();
        btn.setAttribute('aria-disabled', 'true'); // stays focusable: focus is never dropped
        btn.textContent = tpl(I18N.lmAllShown || 'All %TOTAL% products shown', { TOTAL: total });
      }
    }

    window.zgLm.ensureAll = function () {
      if (window.zgLm.complete) { return Promise.resolve(); }
      /* voce 7: a ogni pagina letta si accodano i disponibili; a pagine finite held e poi bufS (prendi) */
      /* Correzioni del revisore (voce 7): una lettura fallita ferma il giro. Prima si ritentava subito e senza fine, gia'
         prima della voce 7: sul banco, con la rete interrotta, circa 28.000 richieste della pagina 2 in 6 s e la griglia
         ferma su «Loading all products…» con le schede a opacita' 0. Ora in griglia va anche quello che il server ha
         gia' mandato (held, bufS) e il filtro lavora su quello; l'indice resta incompleto, quindi nessun conteggio si
         scrive (applyFiltersNow e computeFacetCounts lo vogliono completo), e il prossimo filtro ritenta una volta. */
      const step = () => {
        appendChunk(nextUrl ? bufA.length : resto());
        if (!nextUrl) { updateCount(); finishIfExhausted(); return Promise.resolve(); }
        return fetchNext().then(ok => { if (ok) return step(); appendChunk(resto(), true); });
      };
      return step();
    };

    btn.addEventListener('click', () => {
      if (btn.getAttribute('aria-disabled') === 'true' || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      const need = pageSize; // appendChunk caps at what the buffer holds
      const supply = (letto) => {
        const added = appendChunk(need, letto === false);
        const page = Math.ceil(inDom() / pageSize);
        const u = new URL(window.location.href);
        if (page > 1) u.searchParams.set('page', page); else u.searchParams.delete('page');
        history.replaceState(history.state, '', u.toString());
        if (live) live.textContent = tpl(I18N.lmLoaded || '%COUNT% more products loaded', { COUNT: added });
        updateCount();
        btn.removeAttribute('aria-busy');
        finishIfExhausted();
      };
      /* voce 7: prima si leggono le pagine finche' i disponibili bastano per un giro o le pagine finiscono; poi
         prendi() accoda i disponibili e, solo a pagine finite, gli esauriti. Una lettura fallita (riempi da' false)
         accoda quello che c'e', anche gli esauriti trattenuti (prendi con forza: correzioni del revisore). */
      const riempi = () => (bufA.length >= need || !nextUrl)
        ? Promise.resolve(true)
        : fetchNext().then(ok => (ok ? riempi() : false));
      if (bufA.length >= need || !nextUrl) supply(true);
      else riempi().then(supply);
    });
  }

  /* Full-index guard shared by filters and client-side sort: never operate
     over a partial set — brief indexing state on the grid, announced via
     the polite live region, then run. */
  /* Tappa 1b (critico della tappa 1, basso 14; voce 7): finito l'indice, la scritta «Loading all products…» si toglie
     dalla regione live. Prima restava li' per sempre: dopo un filtro (la regione sta nel blocco di Load more, che i
     filtri nascondono e poi rimostrano) e dopo un ordinamento, chi leggeva la pagina col lettore di schermo trovava
     ancora «Loading all products…» a lavoro finito. Il numero dei risultati lo annuncia la sua regione
     ([data-results-count], aria-live) a indice completo. Si toglie solo se e' ancora la stessa scritta: un «N more
     products loaded» arrivato nel frattempo resta. */
  function withFullIndex(run) {
    if (!window.zgLm || window.zgLm.complete) { run(); return; }
    const grid = document.getElementById('colProductGrid');
    const live = $('[data-zg-lm-live]');
    const attesa = I18N.lmLoadingAll || 'Loading all products…';
    if (grid) grid.classList.add('is-indexing');
    if (live) live.textContent = attesa;
    window.zgLm.ensureAll().then(() => {
      if (grid) grid.classList.remove('is-indexing');
      if (live && live.textContent === attesa) live.textContent = '';
      run();
    });
  }

  /* ── Init ─────────────────────────────────────────────── */
  function boot() {
    // Quick-add for [data-add-to-cart] lives in luxury.js (global, all pages).
    if (!document.getElementById('colProducts')) return;
    initHero();
    // Giro finale, voce 7: initLoadMore prima di initReveals, perche' trattiene gli esauriti della prima pagina prima
    // che animateCardsIn metta opacity 0 in linea alle schede (non dipende da nient'altro qui; initFilters lo vuole prima).
    initLoadMore();
    initReveals();
    initStickyBar();
    initFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: a section re-render replaces the DOM, detaching every
     element-bound listener — re-init. Document-level handlers inside
     initFilters replace themselves, so boot() is re-entrant. */
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('#colProducts')) boot();
  });
})();
